
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/Service/auth.service';
import { CompanyService } from 'src/app/Service/company-service.service';
import { EventService } from 'src/app/Service/event.service';
import { SharedConstants } from 'src/app/models';
import { Provider } from 'src/app/models/shared/Provider';
import { EnumEnrollType, EnumServicesValidation, EnumStatusGeneric } from 'src/app/models/shared/app-enums';
import { CatEnrollSection } from 'src/app/models/shared/cat-generic';
import { CatStatusGeneric } from 'src/app/models/shared/cat-status-generic';
import { CompanyDetailRp, CompanyEditRq, MailNotifs } from 'src/app/models/shared/company';
import { ValidationServices } from 'src/app/models/shared/validation-services';
import { Constants } from 'src/assets/Constats';
import Swal from 'sweetalert2';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form?.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html'
})

export class EditCompanyComponent implements OnInit {
  @Input() childId: string;
  userId: string;
  matcher = new MyErrorStateMatcher();
  fmCompany: FormGroup;
  protected fmTypePerson: FormGroup;
  fmServices: FormGroup;
  fmSections: FormGroup;

  regexEmail: any;
  regexRFC: string;
  currentUser: any;

  show: boolean = false;
  showConfirmPassword: boolean;

  servicesToCompany: ValidationServices[] = [];
  servicesAllCat: ValidationServices[] = [];
  servicesToDelete: ValidationServices[] = [];

  sectionCat_movil_android: CatEnrollSection[] = [];
  sectionCat_movil_iOS: CatEnrollSection[] = [];
  sectionCat_web: CatEnrollSection[] = [];
  sectionCat_web_responsive: CatEnrollSection[] = [];
  sectionToDelete: CatEnrollSection[] = [];
  sectionToEnroll: CatEnrollSection[] = [];

  companyEntity: CompanyDetailRp = {};
  companyRequest: CompanyEditRq = {
    numDocuments: 0,
    servicesToActive: [],
    servicesToRemove: [],
    caeEnabled: true
  };

  catStatus: CatStatusGeneric[] = [];
  catDocuments: CatStatusGeneric[] = [];
  showBioStar: boolean = false;
  listQuestions: any[] = [];
  protected listEmailToNotifs: MailNotifs[] = [
    {
      mail: '',
      isRegex: true,
    }
  ];
  //modulo Asistencia y evidencia
  public isCorrectdataEvidenceAsistense = false;



  protected isCbxFaceComparation: boolean = true;
  protected isCbxLiveness: boolean = true;
  protected providersCAECat: any[] = [];
  private providersCaeSelect: Provider[] = [];
  public isValidCaeProvider: boolean = false;

  showDivUrlINE: boolean = false;
  msg_confirmDelete: string;
  btnYes: string;
  btnCancel: string;

  catMsg = [
    { keyLg: "warningAddService", textValue: "Para continuar es necesario seleccionar por lo menos un servicio." },
    { keyLg: "errorIneURL", textValue: "Ha seleccionado algún servicio de verificación con el INE; es necesario agregar una URL válida." },
    { keyLg: "warningIneURL", textValue: "Es necesario agregar una URL válida." },
    { keyLg: "errorFormValidation", textValue: "Existen errores en los datos. Favor de verificar." },
    { keyLg: "warningPasswordDoNotMatch", textValue: "Las contraseñas no coinciden. Favor de verificar." },
    { keyLg: "errorGetCatData", textValue: "Ocurrió un error al obtener la información del catálogo." },
    { keyLg: "documentsRequired", textValue: "Por favor seleccione la cantidad de documentos." },
    { keyLg: "warningUpdate", textValue: "Las modificaciones realizadas durante esta actualización provocarán cambios en los expedientes existentes de la compañía: " },
    { keyLg: "warningUpdate2", textValue: " ¿Confirma que desea continuar?" },
    { keyLg: "sectionOtherDocumentsRequired", textValue: "Es necesario agregar la sección [OTHER_DOCUMENTS] en algún canal." },
    { keyLg: "biometricRequired", textValue: "Es necesario seleccionar una biometría para cada canal de enrolamiento." },
    { keyLg: "warningAddProvider", textValue: "Para continuar es necesario seleccionar los proveedores correspondientes." },
    { keyLg: "requiredEmailAssistence", textValue: "Asegures de agregar al menos un correo electrónico valido para recibir notificaciones y reportes." },
  ];
  protected regexOnlyNumbers: string;
  protected isEnabled: boolean = false;

  private readonly numbersSections: number = 4;

  /** For managment providers */
  protected catProvidersSections = [
    { id: 1, name: "lblFingerprintCaptureSection" },
    { id: 2, name: "lblOfficialIdCaptureSectionOcr" },
    { id: 3, name: "lblLivenessCheckSection" },
    { id: 4, name: "lblFaceCaptureSection" }
  ];
  protected listProviders: Provider[] = [];
  private providersSelect: Provider[] = [];
  private providersToDelete: Set<number> = new Set<number>();
  private categoriasActivas: { [categoriaId: number]: number } = {};

  private selectFace: boolean = false;
  private selectFingerPrints: boolean = false;

  constructor(
    private readonly sharedConstants: SharedConstants,
    private readonly _fb: FormBuilder,
    private readonly translate: TranslateService,
    private readonly authService: AuthService,
    private readonly _service: CompanyService,
    protected readonly eventService: EventService,
    private readonly _modalService: NgbModal) {

    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;

      console.log(this.currentUser);
    });

    this.regexEmail = this.sharedConstants.regexPattern.email2Validator;
    this.regexRFC = this.sharedConstants.regexPattern.rfc2;
    this.regexOnlyNumbers = this.sharedConstants.regexPattern.numeric;
    this.servicesToCompany = [];
    this.servicesAllCat = [];
    this.servicesToDelete = [];
    this.companyEntity = {};
    this.companyRequest = {
      numDocuments: 0,
      servicesToActive: [],
      servicesToRemove: [],
      caeEnabled: true,
    };

    this.fmCompany = this._fb.group({
      txtCode: ['', [Validators.required, Validators.maxLength(10)]],
      txtName: ['', Validators.required],
      txtRFC: ['', [Validators.required, Validators.maxLength(13), Validators.pattern(this.regexRFC)]],
      txtContactName: ['', Validators.required],
      txtContactEmail: ['', [Validators.required, Validators.maxLength(40), Validators.pattern(this.regexEmail)]],
      rbStatusId: [''],
      txtUserId: ['']
    });

    this.fmTypePerson = this._fb.group({
      //IS OK FOR TYPE PERSONS --- IOMC
      //chckbxFPerson: [{value: true, disabled: true}, Validators.compose([Validators.required])], 
      //chckbxMPerson: [''], 
      mstLightIdentity: [{ value: false, disabled: true }, Validators.compose([Validators.required])],
      assistanceAndEvidenceSection: [{ value: false, disabled: false }, Validators.compose([Validators.required])],
      serverCAE: new FormControl('', Validators.required),
      portCAE: new FormControl('', [Validators.maxLength(5), Validators.pattern(this.regexOnlyNumbers), Validators.required]),
      passwordCAE: new FormControl({ value: '', disabled: true }, Validators.required),
      nameUserCAE: new FormControl({ value: '', disabled: true }, Validators.required),
      A_1: new FormControl({ value: false, disabled: false }),
      B_1: new FormControl({ value: false, disabled: false }),
      A_2: new FormControl({ value: false, disabled: false }),
      B_2: new FormControl({ value: false, disabled: false }),
      A_3: new FormControl({ value: false, disabled: false }),
      B_3: new FormControl({ value: false, disabled: false })
    });

    this.fmServices = this._fb.group({
      txtUrlINE: ['']
    });

    this.fmSections = this._fb.group({
      ddlDocuments: ['']
    });
  }

  ngOnInit(): void {
    this.getDataLanguage();
    console.log("ngOnInit");
    this.fnInitDataLoad();
  }

  protected deleteMailNotifs(idToDelete: number): void {
    this.listEmailToNotifs?.splice(idToDelete, 1);
  }
  protected addMailNotifs(): void {
    var validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
    if (validEmail.test(this.listEmailToNotifs[this.listEmailToNotifs.length - 1].mail)) {
      this.listEmailToNotifs.push({ mail: '', isRegex: true });
    }

  }
  protected setValueMailNotifs(idToEdit: number, event: any): void {
    if (this.listEmailToNotifs) { //Necessary this validation for trackBy on ngFor
      let mailValue: string = event?.target.value;
      this.listEmailToNotifs[idToEdit].mail = mailValue;
      this.listEmailToNotifs[idToEdit].isRegex = (mailValue?.search(this.regexEmail) >= 0);
    }
  }

  async getDataLanguage() {

    this.catMsg.forEach(element => {
      this.translate.stream('companies.catMsg.' + element.keyLg).subscribe((res: string) => {
        element.textValue = res;
      });
    });

    this.msg_confirmDelete = await this.eventService.onTranslate("common.lblConfirmDelete");
    this.btnYes = await this.eventService.onTranslate("common.yes");
    this.btnCancel = await this.eventService.onTranslate("common.btnCancel");
  }

  async fnInitDataLoad() {
    try {
      this.onLoadCat();
    } catch (error) {
      this.eventService.errorMessage(3, "common.catMessage.errorLoadData");
    }
  }

  protected changeBioStar() {
    this.showBioStar = !this.showBioStar;
  }

  get fmDet() { return this.fmCompany.controls; }
  get fmTypePersonG() { return this.fmTypePerson.controls; }
  get fmServicesG() { return this.fmServices.controls; }
  get fmSectionsG() { return this.fmSections.controls; }

  onLoadCat() {

    this.catStatus = [
      {
        id: 1,
        name: "Activa",
        value: "1"
      },
      {
        id: 0,
        name: "Inactiva",
        value: "0"
      }
    ];

    this._service.GetServicesList().subscribe({
      next: (response: any) => {
        console.log("GetServicesList=>", response);
        let _resultado = response.body;
        //Llenar el listado inicial 
        _resultado.forEach(element => {
          this.servicesAllCat.push(
            {
              checked: false,
              description: element.description,
              name: element.name,
              serviceId: element.serviceId,
              enabled: true,
              alreadySelected: false,
            }
          );
        });
        console.log("this.servicesAllCat", this.servicesAllCat);

        this.onLoadEntity();
      },
      error: (error: Response) => {
        this.eventService.errorMessage(3, "common.errorGetCat");
        console.log(error);
      }
    });


    this._service.GetSectionsList().subscribe({
      next: (response: any) => {
        let _resultado = response.body;
        console.log(response);
        console.log(_resultado);
        //Llenar el listado inicial 
        _resultado.forEach(element => {

          if (element.parent == EnumEnrollType.Movil_Android) {
            this.sectionCat_movil_android.push(
              {
                checked: false,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false,
                alreadySelected: false,
              }
            );
          }
          else if (element.parent == EnumEnrollType.Web) {
            this.sectionCat_web.push(
              {
                checked: false,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false,
                alreadySelected: false,
              }
            );
          }

          else if (element.parent == EnumEnrollType.Movil_iOS) {
            this.sectionCat_movil_iOS.push(
              {
                checked: false,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false,
                alreadySelected: false,
              }
            );
          }

          else if (element.parent == EnumEnrollType.Web_responsive) {
            this.sectionCat_web_responsive.push(
              {
                checked: false,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false,
                alreadySelected: false,
              }
            );
          }
        });
      },
      error: (error: Response) => {
        this.eventService.errorMessage(3, "common.errorGetCat");
        console.log(error);
      }
    });

    this.catDocuments = [
      {
        id: 1,
        name: "1 - 5",
        keyLg: "1_5",
        value: "5"
      },
      {
        id: 0,
        name: "6 - 10",
        keyLg: "6_10",
        value: "10"
      },
      {
        id: 0,
        name: "11 - 15",
        keyLg: "11_15",
        value: "15"
      },
      {
        id: 0,
        name: "Más de 15",
        keyLg: "15_",
        value: "16"
      }
    ];

    this.catDocuments.forEach(element => {
      this.translate.stream('companies.' + element.keyLg).subscribe((res: string) => {
        element.name = res;
      });
    });


    this._service.getProvidersCaeList().subscribe({
      next: (response: any) => {
        this.providersCAECat = response?.body;
      },
      complete: () => {
        console.log("Proveedores CAE", this.providersCAECat);
      },
      error: (msg) => {
        this.eventService.completeLoadingData();
        let _msg = this.catMsg.find(x => x.keyLg == "errorGetCatData");
        this.eventService.errorMessage(3, _msg.textValue);
        console.log(msg);
      }
    });


    this.enableProviders();

  }

  onLoadEntity() {
    try {
      this.eventService.startLoadingData();

      console.log(this.childId);
      this._service.GetCompanyDetail(this.childId).subscribe({
        next: res => {
          console.log(res);
          this.companyEntity = res.body;
          console.log("GetCompanyDetail=>", this.companyEntity);
          //Llenar formularios
          let statusValue = this.companyEntity.enabled ? EnumStatusGeneric.Active : EnumStatusGeneric.Inactiva;

          this.fmCompany = this._fb.group({
            txtCode: [{ value: this.companyEntity.id, disabled: true }],
            txtName: [this.companyEntity.name, Validators.required],
            txtRFC: [this.companyEntity.rfc, [Validators.required, Validators.minLength(12), Validators.maxLength(13), Validators.pattern(this.regexRFC)]],
            txtContactName: [this.companyEntity.contactName, Validators.required],
            txtContactEmail: [this.companyEntity.contactEmail, [Validators.required, Validators.minLength(10), Validators.maxLength(40), Validators.pattern(this.regexEmail)]],
            rbStatusId: [statusValue.toString(), Validators.required],
            txtUserId: [{ value: this.companyEntity.userAdmin, disabled: true }]
          });

          this.fmSections = this._fb.group({
            ddlDocuments: [{ value: this.companyEntity.numDocuments.toString(), disabled: true }]
            //ddlDocuments: [this.companyEntity.numDocuments.toString()]
          });

          //Recorrer el listado de servicios y si viene en la compañía entonces se marca para pintar el check 
          this.servicesAllCat.forEach(element => {

            let _service = this.companyEntity.services.find(x => x.serviceId == element.serviceId);
            if (_service !== undefined && _service.enabled == true) {
              this.servicesToCompany.push(element);
              element.alreadySelected = true;
            } else {
              element.alreadySelected = false;
            }

            if (_service !== undefined) {
              if (_service.enabled) {
                element.checked = true;
              }
              else {
                element.checked = false;
              }
            }
            else {
              element.checked = false;
            }

          });

          //Llena cat de secciones           
          this.companyEntity.sections.forEach(element => {

            if (element.enabled) {
              this.sectionToEnroll.push(element);
              //Actualizar el check 
              if (element.parent == EnumEnrollType.Movil_Android) {
                let _item = this.sectionCat_movil_android.find(x => x.sectionId == element.sectionId);
                _item.checked = true;
                _item.alreadySelected = true;
              }
              else if (element.parent == EnumEnrollType.Web) {
                let _item = this.sectionCat_web.find(x => x.sectionId == element.sectionId);
                _item.checked = true;
                _item.alreadySelected = true;
              }
              else if (element.parent == EnumEnrollType.Movil_iOS) {
                let _item = this.sectionCat_movil_iOS.find(x => x.sectionId == element.sectionId);
                _item.checked = true;
                _item.alreadySelected = true;
              }
              else if (element.parent == EnumEnrollType.Web_responsive) {
                let _item = this.sectionCat_web_responsive.find(x => x.sectionId == element.sectionId);
                _item.checked = true;
                _item.alreadySelected = true;
              }

            }
          });

          this.listProviders = this.companyEntity.providers;
          this.providersSelect = [];
          for (let provider of this.listProviders) {
            if (provider.enabled) {
              this.selectProvider(provider.providerId, provider.type, 1);
            }
          }
          if (this.companyEntity.configModCAE != null) {
            this.providersCaeSelect = this.companyEntity.configModCAE?.providers.filter(x => x.enabled);
            this.providersCAECat.forEach(element => {
              let item = this.providersCaeSelect.find(x => x.providerId == element.providerId && x.type == element.type);
              if (item != undefined) {
                element.checked = true;
              }
            });
          }


          console.log("providersCaeSelect", this.providersCaeSelect);
          console.log("sectionCat_movil", this.sectionCat_movil_android);
          console.log("sectionCat_movil_iOS", this.sectionCat_movil_iOS);
          console.log("sectionCat_web", this.sectionCat_web);
          console.log("sectionCat_web_responsive", this.sectionCat_web_responsive);

          //Buscar si algún servicio del INE está marcado 
          let serviceINE = this.servicesToCompany.findIndex(x => x.serviceId == EnumServicesValidation.VERIFICACION_INE_HUELLAS
            || x.serviceId == EnumServicesValidation.VERIFICACION_INE_ROSTRO
            && x.checked);

          console.log("serviceINE", serviceINE);

          if (serviceINE != -1) {
            this.showDivUrlINE = true;
          }
          else {
            this.showDivUrlINE = false;
          }

          this.isEnabled = this.companyEntity.identity;



          //Revisamos si esta activo el modulo de evidencia y asistencia
          this.fmTypePerson.patchValue({
            assistanceAndEvidenceSection: this.companyEntity.caeEnabled
          });

          //Revisanmos si esta activo el modulo de CAE
          const configCAE: any = this.companyEntity.configModCAE;
          if (configCAE) {
            this.fmTypePerson.patchValue({
              mstLightIdentity: this.isEnabled,
              serverCAE: configCAE.ipServer || '',
              portCAE: configCAE.port || '',
              passwordCAE: configCAE.password || '',
              nameUserCAE: configCAE.nameuser || ''
            });
            let emailArray = configCAE.emails && configCAE.emails != '' ? configCAE.emails.split(';') : [];
            let newEmailArray = [];
            if (emailArray.length > 0) {
              //emailArray.pop();
              newEmailArray = emailArray.map((element, index) => {
                return {
                  mail: element,
                  isRegex: true
                }
              });
              newEmailArray = newEmailArray.filter(x => x.mail != '');
            } else {
              newEmailArray = [{ mail: '', isRegex: true }];
            }

            this.listEmailToNotifs = newEmailArray;
          }

          //Mapeamos o inicializamos el formulario de preguntas
          if (this.companyEntity.qconfig.length > 0) {
            this.companyEntity.qconfig.forEach(element => {
              this.fmTypePerson.patchValue({
                [element.key]: element.enabled
              })
            });
          } else {
            let list = [
              {
                questionId: "1",
                parent: 1,
                question: "¿Desea importar los empleados del onboarding?",
                enabled: false,
                key: "A_1"
              },
              {
                questionId: "2",
                parent: 1,
                question: "¿Deseas utilizar la geolocalización del onboarding como ubicación de 'Home Office'?",
                enabled: false,
                key: "B_1"
              },
              {
                questionId: "3",
                parent: 2,
                question: "Comparación de rostro",
                enabled: false,
                key: "A_2"
              },
              {
                questionId: "4",
                parent: 2,
                question: "Prueba de vida",
                enabled: false,
                key: "B_2"
              },
              {
                questionId: "5",
                parent: 3,
                question: "¿Deseas recibir notificaciones y reportes por correo electrónico?",
                enabled: false,
                key: "A_3"
              },
              {
                questionId: "6",
                parent: 3,
                question: "Control de acceso Biostar",
                enabled: this.companyEntity.configModCAE ? true : false,
                key: "B_3"
              }
            ];
            this.companyEntity.qconfig = list;
          }


          this.isCbxFaceComparation = this.companyEntity.qconfig.find(x => x.key == "A_2")?.enabled;
          this.isCbxLiveness = this.companyEntity.qconfig.find(x => x.key == "B_2")?.enabled;

          this.adjustValidatorsBio();
          this.lightIdentity(this.isEnabled, 0);
          this.isCorrectdataEvidenceAsistense = this.checkDataCorrectAssistence();
          this.eventService.completeLoadingData();
        },
        error: error => {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }

  }

  /**
   * Guardar info de type of person and light identity
   * @param isEnabled If is enabled the field light identity
   * @param action Know if is seteo or action by user
   */
  protected lightIdentity(isEnabled: boolean, action: number): void {
    this.fmTypePerson.patchValue({
      mstLightIdentity: isEnabled
    });
    this.isEnabled = isEnabled;

    this.adjustSectionsFirstTime(action);

    this.enableProviders();

  }

  /** Only know if section or service is a biometric */
  private chekSectionServiceBio(name: string): number {
    if (name?.toLocaleUpperCase() === "FACE" || name?.toLocaleLowerCase().includes("rostro") || name?.toLocaleLowerCase().includes("selfie")) {
      return 1;
    } else if (name?.toLocaleUpperCase() === "FINGERPRINTS" || name?.toLocaleLowerCase().includes("huellas")) {
      return 2;
    } else {
      return 0;
    }
  }

  private adjustSectionsFirstTime(action: number): void {//adjustSectionsEnrollments
    this.selectFace = false; this.selectFingerPrints = false;

    let array_sections: any[] = [{ section: this.sectionCat_movil_android }, { section: this.sectionCat_movil_iOS },
    { section: this.sectionCat_web_responsive }, { section: this.sectionCat_web },];

    let isBio: number = 0;
    for (let i = 0; i < array_sections.length; i++) {
      for (let section of array_sections[i].section) {
        isBio = this.chekSectionServiceBio(section.name);
        if (isBio === 2 && this.fmTypePerson.get('mstLightIdentity').value) {
          section.checked = false;
          section.disabled = true;
        } else if (isBio === 2) {
          section.disabled = false;
          if (action === 1) {
            section.checked = true;
          }
        }

        if ((section.name.toLocaleUpperCase() === "FACE" || section.name.toLocaleUpperCase() === "FINGERPRINTS") && section.checked) {
          /** Know bio active */
          if (section.name.toLocaleUpperCase() === "FACE") {
            this.selectFace = true;
          } else {
            this.selectFingerPrints = true;
          }
        }

        if (action === 1) { //Only when press light idetity
          let event = { checked: section.checked };
          this.onChangeCheckSection(event, section, "");
        }

      }
    }

    this.adjustServicesByLightIdentity(action);

  }

  private adjustServicesByLightIdentity(action: number): void {
    let isBio: number = 0;
    let event = { checked: false };
    this.servicesAllCat.forEach(service => {
      isBio = this.chekSectionServiceBio(service.name);
      if (isBio === 2 && this.fmTypePerson.get('mstLightIdentity').value) {
        service.checked = false;
        service.enabled = false;

        event.checked = service.checked;
        this.onChangeCheckService(event, service);
      } else if (isBio === 2) {
        service.enabled = (this.selectFingerPrints);
        if (action === 1) {
          service.checked = true;
          event.checked = service.checked;
          this.onChangeCheckService(event, service);
        }
        if (!this.selectFingerPrints) {
          service.checked = false;
          //Adjust services
          event.checked = service.checked;
          this.onChangeCheckService(event, service);
        }
      } else if (isBio === 1) {
        service.enabled = (this.selectFace);
        if (!this.selectFace) {
          service.checked = false;
          //Adjust services
          event.checked = service.checked;
          this.onChangeCheckService(event, service);
        }
      }

    });

    this.enableProviders();

  }

  onChangeCheckService(event: any, item: ValidationServices) {
    let _checked = event.checked;
    let _exist = this.servicesToCompany?.findIndex(x => x.serviceId == item.serviceId);

    if (_exist == -1 && _checked) {
      this.servicesToCompany?.push(item);
    }

    //Si existe y está marcado entonces eliminar
    if (_exist != undefined && _exist != -1 && !event.checked) {
      this.servicesToCompany?.splice(_exist, 1);

      //Buscar si no existe en la lista para eliminar y agregarlo a la lista
      //Buscar si el registro viene desde la bd; si existe entonces buscar en la lista para eliminar
      //si no existe entonces se agrega para eliminar       
      let _serviceBD = this.companyEntity.services.findIndex(x => x.serviceId == item.serviceId);
      let _serviceNew = this.servicesToDelete.findIndex(x => x.serviceId == item.serviceId);
      if (_serviceBD != -1 && _serviceNew == -1) {
        this.servicesToDelete.push(item);
      }
    }

    //Mark to true or false the CatEnrollSection
    let service: ValidationServices = this.servicesAllCat?.find(x => x.serviceId == item.serviceId);
    if (service) {
      service.checked = event.checked;
    }

    let serviceINE = this.servicesToCompany.findIndex(x => x.serviceId == EnumServicesValidation.VERIFICACION_INE_HUELLAS || x.serviceId == EnumServicesValidation.VERIFICACION_INE_ROSTRO);
    if (serviceINE != -1) {
      this.showDivUrlINE = true;
    } else {
      this.showDivUrlINE = false;
    }

  }

  onClose() {
    this.catStatus = [];
    this.servicesToCompany = [];
    this.servicesAllCat = [];
    this.servicesToDelete = [];
    this.companyEntity = {};
    this.companyRequest = {
      numDocuments: 0,
      servicesToActive: [],
      servicesToRemove: [],
      caeEnabled: true,
    };
    this._modalService.dismissAll();
  }

  /**
   * Validating if user select at least section of face or finger, (bio technology), is necessary at least for continued
   */
  protected validatingBioSections(): void {

    /** Count of biometric technology selected by patent */
    let bioSections: Set<number> = new Set<number>();

    this.sectionToEnroll.sort((a: any, b: any) => b.parent - a.parent).forEach(element => {
      if ((element.name.toLocaleUpperCase() === "FACE" || element.name.toLocaleUpperCase() === "FINGERPRINTS") && (element.checked || element['enabled'])) {
        bioSections.add(element.parent);
      }
    });

    this.isCorrectdataEvidenceAsistense = this.checkDataCorrectAssistence();



    /** Verify if count of sections is match with total sections */
    if ((bioSections.size === this.numbersSections) && this.isCorrectdataEvidenceAsistense) {
      this.onSaveCompanyInfo();
    } else {
      if (!this.isCorrectdataEvidenceAsistense) {
        let _msg = this.catMsg.find(x => x.keyLg == "requiredEmailAssistence");

        if (!this.isValidCaeProvider) {
          _msg = this.catMsg.find(x => x.keyLg == "companies.assistance.errorCaeProvider");
          this.eventService.warningMessage("companies.assistance.errorCaeProvider");
        }
        else {
          this.eventService.errorMessage(0, _msg.textValue);
        }


      } else {
        let _msg = this.catMsg.find(x => x.keyLg == "biometricRequired");
        this.eventService.errorMessage(0, _msg.textValue);
      }

    }
  }

  //Guardar info de la compañia
  onSaveCompanyInfo() {

    let urlServiceINE = this.fmServices.get("txtUrlINE")?.value;
    //Validar que exista al menos un servicio para la compañía 
    if (this.servicesToCompany.length == 0) {
      let _msg = this.catMsg.find(x => x.keyLg == "warningAddService");
      this.eventService.warningMessage(_msg.textValue);
      return;
    }

    if (this.fmCompany.invalid) {
      this.eventService.warningMessage("Existen errores en los datos. Favor de verificar.");
      return;
    }

    //Validar si algún servicio de verificación del INE se está activando 
    let _serviceIne = this.servicesToCompany.findIndex(x => x.serviceId == EnumServicesValidation.VERIFICACION_INE_HUELLAS || x.serviceId == EnumServicesValidation.VERIFICACION_INE_ROSTRO);
    if (_serviceIne != -1 && urlServiceINE.length == 0) {
      let _msg = this.catMsg.find(x => x.keyLg == "errorIneURL");
      this.eventService.errorMessage(0, _msg.textValue);
      return;
    }

    if (this.showDivUrlINE && !this.validarURL(urlServiceINE)) {
      let _msg = this.catMsg.find(x => x.keyLg == "warningIneURL");
      this.eventService.warningMessage(_msg.textValue);
      return;
    }

    let _idSections = [];
    this.sectionToEnroll.forEach(element => {
      _idSections.push(element.sectionId)
    });

    let _idSectionsToRemove = [];
    this.sectionToDelete.forEach(element => {
      _idSectionsToRemove.push(element.sectionId)
    });

    let document = this.companyEntity.numDocuments;
    //Buscar la sección OTHER_DOCUMENTS 
    let otherDoc = this.sectionToEnroll.findIndex(x => x.name == "OTHER_DOCUMENTS");
    console.log(otherDoc);
    if (otherDoc != -1) {
      document = this.fmSections.get("ddlDocuments")?.value;
      console.log(document);
      if (document == 0) {
        let _msg = this.catMsg.find(x => x.keyLg == "documentsRequired");
        this.eventService.errorMessage(0, _msg.textValue);
        return;
      }
    }

    if (otherDoc == -1 && document > 0) {
      let _msg = this.catMsg.find(x => x.keyLg == "sectionOtherDocumentsRequired");
      this.eventService.errorMessage(0, _msg.textValue);
      return;
    }



    /** Validación de proveedores */
    if (Object.keys(this.categoriasActivas).length !== this.providersSelect.length) {
      let _msg = this.catMsg.find(x => x.keyLg == "warningAddProvider");
      this.eventService.warningMessage(_msg.textValue);
      return;
    }

    let providersIdSelectFinal: number[] = [];
    this.providersSelect.forEach(element => {
      providersIdSelectFinal.push(element.providerId);
    });
    let providersIdDeleteFinal: number[] = [];
    this.providersToDelete.forEach(element => {
      providersIdDeleteFinal.push(element);
    });






    let warningUpdate = this.catMsg.find(x => x.keyLg == "warningUpdate");
    let warningUpdate2 = this.catMsg.find(x => x.keyLg == "warningUpdate2");

    Swal.fire({
      text: warningUpdate.textValue + this.companyEntity.id + warningUpdate2.textValue,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.btnYes,
      denyButtonText: "No",
      cancelButtonText: this.btnCancel,
      confirmButtonColor: Constants.SWEET_ALERT_PROPERTIES.confirmButtonColor,
      cancelButtonColor: Constants.SWEET_ALERT_PROPERTIES.cancelButtonColor,
    }).then((result) => {

      //this.authService.onValidateCookieUserUI();
      let s_userId = localStorage.getItem("userId");
      if (result.value) {

        if (result.isConfirmed && s_userId == this.currentUser.id.toString()) {
          //this.eventService.startLoadingData();
          let _statusCompany = this.fmCompany.get("rbStatusId")?.value;

          let _servicesToActive = [];
          this.servicesToCompany.forEach(element => {
            _servicesToActive.push(element.serviceId)
          });

          let _servicesToRemove = [];
          this.servicesToDelete.forEach(element => {
            _servicesToRemove.push(element.serviceId)
          });


          //Llenar info            
          this.companyRequest.name = this.fmCompany.get("txtName")?.value;
          this.companyRequest.rfc = this.fmCompany.get("txtRFC")?.value;
          this.companyRequest.contactName = this.fmCompany.get("txtContactName")?.value;
          this.companyRequest.contactEmail = this.fmCompany.get("txtContactEmail")?.value;
          this.companyRequest.servicesToActive = _servicesToActive;
          this.companyRequest.servicesToRemove = [];//_servicesToRemove;
          this.companyRequest.enabled = (_statusCompany == "1");
          this.companyRequest.userId = this.currentUser.id;
          this.companyRequest.numDocuments = document;
          this.companyRequest.sectionsToActive = _idSections;
          this.companyRequest.sectionsToRemove = [];//_idSectionsToRemove;

          this.companyRequest.providersToActive = providersIdSelectFinal;
          this.companyRequest.providersToRemove = providersIdDeleteFinal;
          this.companyRequest.identity = this.fmTypePerson.get('mstLightIdentity').value;

          /** THIS FIELS ARE SET DEFAULT BY GET DETAIL COMPANY, IS ANYONE ACTION IN FRONT TO EDIT */


          //Damos valores al request de asistencia y evidencia
          this.setDataRequestAssistenceAndEvidence();




          console.log("Company =>", this.companyRequest);
          this._service.EditCompanyDetail(this.companyEntity.id, this.companyRequest).subscribe({
            next: res => {
              console.log(res);
              this.eventService.completeLoadingData();
              this._modalService.dismissAll();
              this.onClearData();
              //recargar pantalla
              setTimeout(() => {
                //window.location.reload();
              }, 2000);
              this.eventService.successMessage(1);
            },
            error: error => {
              console.log(error);
              this.eventService.completeLoadingData();
              this.eventService.errorMessage(0, "Ocurrió un error al procesar su solicitud.");
            }
          });
        }
        else if (s_userId != this.currentUser.id.toString()) {
          Swal.close();
          window.location.reload();
          this.eventService.completeLoadingData();
        }
        else if (result.isDenied) {
          Swal.close();
        }
      }
    });

  }

  //Preparamos los datos para enviar a la API
  private setDataRequestAssistenceAndEvidence(): void {

    let questionsToActive: number[] = [];
    let questionsToRemove: number[] = [];

    //Asignamos el valor de la sección de asistencia y evidencia
    this.companyRequest.caeEnabled = this.fmTypePersonG.assistanceAndEvidenceSection.value;


    //Convertimos los emails a un string
    let listEmails = this.listEmailToNotifs.map((element) => {
      var validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
      const email = validEmail.test(element.mail.trim());
      if (email) {
        return element.mail;
      } else {
        return null;
      }
    }).filter(element => element != null).join(';');

    console.log("listEmails", listEmails);

    if (listEmails == '') {
      this.fmTypePersonG['A_3'].setValue(false);
    }


    let configModCAE = {
      nameUser: this.fmTypePersonG.nameUserCAE.value || '',
      password: this.fmTypePersonG.passwordCAE.value || '',
      ipServer: this.fmTypePersonG.serverCAE.value || '',
      port: this.fmTypePersonG.portCAE.value || '',
      emails: listEmails || '',
      providersToActive: this.providersCaeSelect.map(provider => provider.providerId),
      providersToRemove: this.companyEntity.configModCAE?.providers.filter(x => x.enabled).map(provider => provider.providerId)
    }

    if (this.fmTypePersonG.portCAE.value == '' || this.fmTypePersonG.serverCAE.value == '') {
      this.fmTypePersonG['B_3'].setValue(false);
    }

    //asignamos informacion al modulo CAE
    this.companyRequest.configModCAE = configModCAE;

    //Asignamos un valor inicial a las preguntas
    this.companyEntity?.qconfig.forEach(element => {
      let index = element.key
      const data = this.fmTypePersonG[index].value;
      if (data) {
        questionsToActive.push(parseInt(element?.questionId));
      } else {
        questionsToRemove.push(parseInt(element?.questionId));
      }
    });

    //Asignamos las preguntas activas y las que se van a eliminar
    this.companyRequest.questionsToActive = questionsToActive;
    this.companyRequest.questionsToRemove = questionsToRemove;

  }

  validarURL(miurl) {
    try {
      new URL(miurl);
      return true;
    } catch (err) {
      return false;
    }
  }

  onClearData() {
    this.catStatus = [];
    this.servicesToCompany = [];
    this.servicesAllCat = [];
    this.servicesToDelete = [];
    this.companyEntity = {};
    this.companyRequest = {
      numDocuments: 0,
      servicesToActive: [],
      servicesToRemove: [],
      caeEnabled: true,
    };
  }

  onKeyPress(event: any) {
    if (event.target.attributes) {
      let datavalidInput = event.target.attributes["data-valid"]["value"];
      if (datavalidInput != undefined && datavalidInput == "notnumber") {
        let keyCode = event.keyCode;

        if ((keyCode >= 48 && keyCode <= 57)) {
          return false;
        }
      }
    }
  }

  modelChanged(newObj: any) {
    let value = newObj.target.value;
    //console.log("value", value);
    if (newObj.target.attributes) {
      let dataTypeInput = newObj.target.attributes["data-type"]["value"];
      let datavalidInput = newObj.target.attributes["data-valid"]["value"];
      if (datavalidInput != undefined && datavalidInput == "notnumber") {
        let keyCode = newObj.keyCode;
        if ((keyCode >= 48 && keyCode <= 57)) {
          newObj.target.value = value.replace(newObj.key, "");
        }
      }

      if (dataTypeInput == "notspace") {
        newObj.target.value = value.trim();
      }
      else if (dataTypeInput == "notdoublespace") {
        let count = 0;
        let position = value.indexOf(" ");
        while (position !== -1) {
          count++;
          position = value.indexOf(" ", position + 1);
        }
        if (count > 1 && value.length == 6) {
          newObj.target.value = value.trim();
        } else if (count > 6) {
          newObj.target.value = value.trim();
        }
      }
    }
  }

  onChangeCheckSection(event: any, item: CatEnrollSection, sectionName: string) {
    let _checked = event.checked;
    let _exist = this.sectionToEnroll?.findIndex(x => x.sectionId == item.sectionId);

    if (_exist == -1 && _checked) {
      this.sectionToEnroll?.push(item);
    }

    //Si existe y está marcado entonces eliminar
    if (_exist != undefined && _exist != -1 && !event.checked) {
      this.sectionToEnroll?.splice(_exist, 1);

      let _sectionBD = this.companyEntity.sections.findIndex(x => x.sectionId == item.sectionId);
      let _sectionNew = this.sectionToDelete.findIndex(x => x.sectionId == item.sectionId);
      if (_sectionBD != -1 && _sectionNew == -1) {
        this.sectionToDelete.push(item);
      }
    }

    //Mark to true the CatEnrollSection
    let section: CatEnrollSection = this[sectionName]?.find(x => x.sectionId == item.sectionId);
    if (section) {
      section.checked = event.checked;
    }

    this.adjustSectionsFirstTime(2);

  }

  /** Enabled or disabled sections provider about CA of HU ( Configuración de proveedores para módulos Captura de rostro, Captura de huellas, Captura de identificación oficial ) */
  protected enableProviders(): void {
    this.categoriasActivas = {};
    for (let provider of this.listProviders) {
      /**
       * CA: Cuando se haya elegido la opción de identidad Ligera, los proveedores de huella no deberán estar habilitados. 
       */
      if (provider.type === 1) {
        provider.disabledFront = ((this.fmTypePerson.get('mstLightIdentity').value) || !this.selectFingerPrints);
        if (provider.disabledFront) {
          provider.enabled = false;
          //Adjust providers
          this.selectProvider(provider.providerId, provider.type, 2);
        }
      }
      /**
       * CA: Los proveedores de captura de identificación oficial deberán estar siempre habilitados de tal forma que pueden seleccionar un proveedor de la lista. 
       */
      if (provider.type === 2) {
        provider.disabledFront = false;
      }
      /**
       * CA: La sección de comparación de rostro siempre estará habilitada sin excepción.
       */
      if (provider.type === 3) {
        provider.disabledFront = false;
      }
      /**
       * CA: Si no se selecciona la sección de captura de rostro, se deberán deshabilitar los proveedores de captura de rostro.
       */
      if (provider.type === 4) {
        provider.disabledFront = !this.selectFace;
        if (provider.disabledFront) {
          provider.enabled = false;
          //Adjust providers
          this.selectProvider(provider.providerId, provider.type, 2);
        }
      }

      if (!provider.disabledFront) {
        const categoriaId = provider.type;
        if (!this.categoriasActivas[categoriaId]) {
          this.categoriasActivas[categoriaId] = 1;
        } else {
          this.categoriasActivas[categoriaId]++;
        }
      }

    }

  }

  /** When user selected a provider, add the provider and delete other with same type */
  protected selectProvider(id: number, type: number, action: number): void {

    for (let provider of this.listProviders) {
      if (provider.type === type) {
        if (provider.providerId === id) {
          /** Add provider */
          if (action === 1) {
            this.providersSelect.push(this.listProviders.find(p => p.providerId === id));
            provider.enabled = true;
            this.providersToDelete.delete(provider.providerId);
          }
        } else {
          /** Delete provider */
          let providerToDelete = this.providersSelect.find(p => p.providerId !== id && p.type === type);
          if (providerToDelete) {
            let indice = this.providersSelect.indexOf(providerToDelete);
            this.providersSelect.splice(indice, 1);
            this.providersToDelete.add(providerToDelete.providerId);
          }
          provider.enabled = false;
        }
      }
    }
  }


  public adjustValidatorsBio(): void {
    if (this.fmTypePersonG.assistanceAndEvidenceSection.value && this.fmTypePersonG.B_3.value) {
      //this.fmTypePersonG.nameUserCAE.enable();
      //this.fmTypePersonG.passwordCAE.enable();
      this.fmTypePersonG.serverCAE.enable();
      this.fmTypePersonG.portCAE.enable();
      this.fmTypePersonG.nameUserCAE.addValidators(Validators.required);
      //this.fmTypePersonG.passwordCAE.addValidators(Validators.required);
      this.fmTypePersonG.serverCAE.addValidators(Validators.required);
      this.fmTypePersonG.portCAE.addValidators([Validators.maxLength(5), Validators.pattern(this.regexOnlyNumbers), Validators.required]);
      this.updateValueAndValidityFormBio();
    } else {
      this.fmTypePersonG.nameUserCAE.disable();
      this.fmTypePersonG.passwordCAE.disable();
      this.fmTypePersonG.serverCAE.disable();
      this.fmTypePersonG.portCAE.disable();
      this.fmTypePersonG.nameUserCAE.removeValidators(Validators.required);
      this.fmTypePersonG.passwordCAE.removeValidators(Validators.required);
      this.fmTypePersonG.serverCAE.removeValidators(Validators.required);
      this.fmTypePersonG.portCAE.removeValidators([Validators.maxLength(5), Validators.pattern(this.regexOnlyNumbers), Validators.required]);
      this.updateValueAndValidityFormBio();
    }


  }


  onChangeCheckQuestion(event: any, item: any) {
    console.log(event);
    if (item.key === 'B_3') {
      this.adjustValidatorsBio();
    }
    if (item.key === 'A_3') {
      if (this.listEmailToNotifs.length <= 0) {
        this.listEmailToNotifs.push({ mail: '', isRegex: true });

      }
    }

    if (item.questionId == "3") {
      this.isCbxFaceComparation = (item.questionId == "3" && event.checked);
      console.log(">>>", this.providersCaeSelect);
      if (!event.checked)
        this.providersCaeSelect = this.providersCaeSelect.filter(provider => provider.type !== 1);

      this.onValidateProvidersCAE();
    }

    if (item.questionId == "4") {
      this.isCbxLiveness = (item.questionId == "4" && event.checked);
      if (!event.checked)
        this.providersCaeSelect = this.providersCaeSelect.filter(provider => provider.type !== 2);
      this.onValidateProvidersCAE();
    }

  }

  public checkDataCorrectAssistence(): boolean {
    if (this.fmTypePersonG.assistanceAndEvidenceSection.value) {
      //Revisamos si esta activo el checkbox de recibir notificaciones
      var validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
      if (this.fmTypePersonG.A_3.value) {
        //Revisamos si se ingreso algun correo
        if (this.listEmailToNotifs.length <= 0) {
          return false;
        } else if (this.listEmailToNotifs.length == 1) {
          if (this.listEmailToNotifs[0].mail.trim() == '' || !validEmail.test(this.listEmailToNotifs[0].mail.trim())) {
            return false;
          }
        } else {
          for (let email of this.listEmailToNotifs) {
            if (email.mail.trim() == '' || !validEmail.test(email.mail.trim())) {
              return false;
            }
          }
        }
      }

      this.onValidateProvidersCAE();
      if (!this.isValidCaeProvider) {
        return false;
      }
    }
    return true;
  }

  private updateValueAndValidityFormBio(): void {

    this.fmTypePerson.get('nameUserCAE').updateValueAndValidity();
    this.fmTypePerson.get('passwordCAE').updateValueAndValidity();
    this.fmTypePerson.get('serverCAE').updateValueAndValidity();
    this.fmTypePerson.get('portCAE').updateValueAndValidity();
  }


  protected selectProviderCAE(id: number, type: number): void {
    console.log("Click proveedor CAE", this.providersCaeSelect);
    for (let provider of this.providersCAECat) {
      if (provider.type === type) {
        if (provider.providerId === id) {
          const exists = this.providersCaeSelect.some(p => p.providerId === id);
          if (!exists) {
            this.providersCaeSelect.push(provider);
          }

        }
        else {
          /** Delete provider */
          let providerToDelete = this.providersCaeSelect.find(p => p.providerId !== id && p.type === type);
          if (providerToDelete) {
            let indice = this.providersCaeSelect.indexOf(providerToDelete);
            this.providersCaeSelect.splice(indice, 1);
          }
        }
      }
    }
    this.onValidateProvidersCAE();

  }


  onValidateProvidersCAE(): void {

    console.log("this.isCbxFaceComparation", this.isCbxFaceComparation);
    console.log("this.isCbxLiveness", this.isCbxLiveness);

    let isValidFace = false;
    if (this.isCbxFaceComparation) {
      isValidFace = this.providersCaeSelect.filter(provider => provider.type === 1).length > 0;
    }
    else { 
      isValidFace = this.providersCaeSelect.filter(provider => provider.type === 1).length == 0;
    }

    let isValidLiveness = false;
    if (this.isCbxLiveness) {
      isValidLiveness = this.providersCaeSelect.filter(provider => provider.type === 2).length > 0;
    }
    else { 
      isValidLiveness = this.providersCaeSelect.filter(provider => provider.type === 2).length == 0;
    } 
    this.isValidCaeProvider = isValidFace && isValidLiveness;  
    this.providersCAECat.forEach(element => {
      let item = this.providersCaeSelect.find(x => x.providerId == element.providerId && x.type == element.type);
      console.log("item", item);
      if (item != undefined) {
        element.checked = true;
      }
      else {
        element.checked = false;
        console.log("CAMBIAR", element);
      }
    });

  }
}
